// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"5ecca94c","669":"031c6162"}[chunkId] + ".chunk.css";
};